export const INPUT_BORDER_COLOR = '#dbd6d6';
export const COLOR_MESSAGE_FORM_ERROR = '#dd6868';
export const GRAY_LIGHT = '#F6F6F6';
export const FONT_COLOR_APP = '#2F4249';
export const IN_PROGRESS_COLOR = '#ffb42e';
export const SUCESS_COLOR = '#2cd13c';
export const ERROR_COLOR = '#ed4e4e';
export const GREY_BACKGROUND_COLOR_APP = '#fcfcfc';

export const PRIMARY_COLOR_APP = '#1D364C';
export const XMEI_PRIMARY_COLOR = '#030d4f';
export const XMEI_SECONDARY_COLOR = '#ff8931';
export const COLORS = [
  '#347deb',
  '#ff8931',
  '#F5F505',
  '#FF4500',
  '#FFBB28',
  '#8884d8',
  '#FE0F00',
  '#8CF505',
  '#F505E0',
  '##959595',
  '#000000',
];
export const MSG_ERRO = 'Houve um erro de comunicação,tente mais tarde!';
export const CAMPO_OBRIGATORIO = '* Campo Obrigatório';
export const UFS = [
  'AC',
  'AL',
  'AM',
  'AP',
  'BA',
  'CE',
  'DF',
  'ES',
  'GO',
  'MA',
  'MT',
  'MS',
  'MG',
  'PA',
  'PB',
  'PR',
  'PE',
  'PI',
  'RJ',
  'RN',
  'RO',
  'RS',
  'RR',
  'SC',
  'SE',
  'SP',
  'TO',
];

export const UFS_OPTIONS = [
  {
    label: 'AC',
    value: 'AC',
  },
  {
    label: 'AL',
    value: 'AL',
  },
  {
    label: 'AM',
    value: 'AM',
  },
  {
    label: 'AP',
    value: 'AP',
  },
  {
    label: 'BA',
    value: 'BA',
  },
  {
    label: 'CE',
    value: 'CE',
  },
  {
    label: 'DF',
    value: 'DF',
  },
  {
    label: 'ES',
    value: 'ES',
  },
  {
    label: 'GO',
    value: 'GO',
  },
  {
    label: 'MA',
    value: 'MA',
  },
  {
    label: 'MT',
    value: 'MT',
  },
  {
    label: 'MS',
    value: 'MS',
  },
  {
    label: 'MG',
    value: 'MG',
  },
  {
    label: 'PA',
    value: 'PA',
  },
  {
    label: 'PB',
    value: 'PB',
  },
  {
    label: 'PR',
    value: 'PR',
  },
  {
    label: 'PE',
    value: 'PE',
  },
  {
    label: 'PI',
    value: 'PI',
  },
  {
    label: 'RJ',
    value: 'RJ',
  },
  {
    label: 'RN',
    value: 'RN',
  },
  {
    label: 'RO',
    value: 'RO',
  },
  {
    label: 'RS',
    value: 'RS',
  },
  {
    label: 'RR',
    value: 'RR',
  },
  {
    label: 'SC',
    value: 'SC',
  },
  {
    label: 'SE',
    value: 'SE',
  },
  {
    label: 'SP',
    value: 'SP',
  },
  {
    label: 'TO',
    value: 'TO',
  },
];
export const uuidAbertura = '0f36236d-e234-4656-a6e8-6ea2ac5dcf8d';
export const uuidAberturaMEI = 'd490cb59-db44-4a6b-87b9-07a285d79236';
